import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../page/Login";
import VehicleAccount from "../page/VehicleAccount";
import Dashboard from "../page/Dashboard";
import FocMaster from "../page/FocMaster";
import History from "../page/VehicleHistory";
import Corporate from "../page/Enterprises";
import DriverCalls from "../page/DriverCalls";
import PrepaidTrip from "../page/PrepaidTrip";
import CorporateAccount from "../page/CorporateAccount";
import CorporateHistory from "../page/CorporateHistory";
import CorporateTrip from "src/page/CorporateTrip";
import DriverAtten from "src/page/DriverAtten";
import SidebarMenu from "src/page/SidebarMenu";
import Booking_Report from "src/page/Booking_Report";
import OwnerDetails from "src/page/OwnerDetails";
import DriverDetails from "src/page/DriverDetails";
import Enterprises from "../page/Enterprises";
import StatusReport from "src/page/StatusReport";
import VehicleMaster from "src/page/VehicleMaster";
import RemovedVehicle from "src/page/RemovedVehicle";

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const isLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

const ProtectedRoute = ({
  children,
  tabKey,
}: {
  children: JSX.Element;
  tabKey: string;
}) => {
  const hasLock = localStorage.getItem(`tab-lock-${tabKey}`);
  return hasLock ? children : <Navigate to="/dashboard" replace />;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Navigate to="/login" />} />

      <Route
        path="dashboard"
        element={
          <RequireAuth>
            <SidebarMenu />
          </RequireAuth>
        }
      >
        {/* <Route index element={<Dashboard />} /> */}

        <Route path="home" element={<Dashboard />} />

        <Route
          path="vehicleaccount"
          element={
            <ProtectedRoute tabKey="vehicleaccount">
              <VehicleAccount />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="focmaster"
          element={
            <ProtectedRoute tabKey="focmaster">
              <FocMaster />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="drivercalls"
          element={
            <ProtectedRoute tabKey="drivercalls">
              <DriverCalls />
            </ProtectedRoute>
          }
        />
        <Route
          path="paymentreport"
          element={
            <ProtectedRoute tabKey="paymentreport">
              <History />
            </ProtectedRoute>
          }
        />
        <Route
          path="enterprises"
          element={
            <ProtectedRoute tabKey="enterprises">
              <Enterprises />
            </ProtectedRoute>
          }
        />
        <Route
          path="vehiclemaster"
          element={
            <ProtectedRoute tabKey="vehiclemaster">
              <VehicleMaster />
            </ProtectedRoute>
          }
        />
        <Route
          path="exidevehicle"
          element={
            <ProtectedRoute tabKey="exidevehicle">
              <RemovedVehicle />
            </ProtectedRoute>
          }
        />
        <Route
          path="corporatetrip"
          element={
            <ProtectedRoute tabKey="corporatetrip">
              <CorporateTrip />
            </ProtectedRoute>
          }
        />
        <Route
          path="prepaidtrip"
          element={
            <ProtectedRoute tabKey="prepaidtrip">
              <PrepaidTrip />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="corporateaccount"
          element={
            <ProtectedRoute tabKey="corporateaccount">
              <CorporateAccount />
            </ProtectedRoute>
          }
        /> */}
        {/* <Route
          path="corporatehistory"
          element={
            <ProtectedRoute tabKey="corporatehistory">
              <CorporateHistory />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="driverattendance"
          element={
            <ProtectedRoute tabKey="driverattendance">
              <DriverAtten />
            </ProtectedRoute>
          }
        />
        <Route
          path="booking_page"
          element={
            <ProtectedRoute tabKey="booking_page">
              <Booking_Report />
            </ProtectedRoute>
          }
        />
        <Route
          path="ownerdetails"
          element={
            <ProtectedRoute tabKey="ownerdetails">
              <OwnerDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="driverdetails"
          element={
            <ProtectedRoute tabKey="driverdetails">
              <DriverDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="statusreport"
          element={
            <ProtectedRoute tabKey="statusreport">
              <StatusReport />
            </ProtectedRoute>
          }
        />
        <Route />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
};

export default AppRoutes;
